<template>
    <div v-if="user">
        <va-loading v-if="loading" size="md" :center="true" />

        <va-page-header>
            <div slot="title">
                <span>{{ _(sectionCapitalized) + ' ' + _('Meta Forms') }}</span>
            </div>

            <div slot="actions">
                <va-button
                    @click.native="navigate('/' + $route.matched[0].name + '/' + $route.params.scope + '/' + $route.params.category + '/meta-forms/new')"
                    style="position: absolute; right: 22px; top: 20px;" type="primary" size="lg"
                    v-if="user.get('roles').includes('admin') || user.get('roles').includes('manager') || user.get('roles').includes(section + '-editor')">
                    {{ _('NEW META FORM') }}</va-button>
            </div>

        </va-page-header>

        <div v-if="allSectionFormsCount !== 0">
            <va-row :gutter="12">
                <va-column :lg="12" :md="12" :sm="12">
                    <va-table hover fullWidth class="datatable">
                        <table :dir="getDirectionStatus">
                            <thead>
                                <tr>
                                    <th :class="{rtlTableHead: getSystemLanguage != 'english'}">{{ _('Name') }}</th>
                                    <th :class="{rtlTableHead: getSystemLanguage != 'english'}">{{ _('Created By') }}
                                    </th>
                                    <th :class="{rtlTableHead: getSystemLanguage != 'english'}">{{ _('Languages') }}
                                    </th>
                                    <th :class="{rtlTableHead: getSystemLanguage != 'english'}">{{ _('Date') }}</th>
                                    <th :class="{rtlTableHead: getSystemLanguage != 'english'}">{{ _('Enabled') }}</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(form, index) in perPageSectionForms">
                                    <td :class="{rtlTd: getSystemLanguage != 'english'}">
                                        <a style="cursor:pointer"
                                            @click="navigate('/' + $route.matched[0].name + '/meta-forms/preview/' + form.id)">
                                            {{ g_getLabel(form) }}</a>
                                    </td>

                                    <td :class="{rtlTd: getSystemLanguage != 'english'}">
                                        {{form.get('createdBy')!=null ? form.get('createdBy').get('name') : 'n/a'}}
                                    </td>

                                    <td :class="{rtlTd: getSystemLanguage != 'english'}">
                                        <div style="display: flex">
                                            <div>
                                                <span
                                                    v-for="(language, index) in form.get('form_languages').slice(0, 3)"
                                                    class="name_in_list">
                                                    {{ language != 'english' ? _(language) : language }}</span>
                                            </div>

                                            <va-dropdown triggerEvent="hover"
                                                v-if="form.get('form_languages').length > 3">
                                                <div slot="trigger">
                                                    <span class="name_in_list">...</span>
                                                </div>
                                                <div v-for="(language, index) in form.get('form_languages')"
                                                    style="margin: 5px">
                                                    <span>{{language}}</span>
                                                </div>
                                            </va-dropdown>
                                        </div>
                                    </td>
                                    <td :class="{rtlTd: getSystemLanguage != 'english'}">
                                        {{new Date(form.createdAt).getFullYear() + '-' + parseInt(1 +
                                        new
                                        Date(form.createdAt).getMonth())+ '-' + new
                                        Date(form.createdAt).getDate()}}
                                    </td>
                                    <td :class="{rtlTd: getSystemLanguage != 'english'}">
                                        <div style="display: flex; justify-content: space-around; width: 70px">
                                            <va-tooltip :content="_('Edit')" trigger="hover" placement="top">
                                                <va-icon class="actions_btn"
                                                    @click.native="navigate('/' + $route.matched[0].name + '/' + $route.params.scope + '/' + $route.params.category + '/meta-forms/' + form.id)"
                                                    type="edit" color="gray"></va-icon>
                                            </va-tooltip>
                                            <va-tooltip :content="_('Delete')" trigger="hover" placement="top">
                                                <va-icon class="actions_btn" @click.native="deleteObject(form)"
                                                    type="trash" color="gray"></va-icon>
                                            </va-tooltip>
                                        </div>
                                    </td>
                                </tr>

                            </tbody>
                        </table>
                    </va-table>

                </va-column>
            </va-row>

            <va-row :gutter="12">

                <va-column :lg="12" :sm="12">
                    <div style="display: flex">
                        <v-page :class="{no_click: allSectionFormsCount==0}" :key="$route.path"
                            :total-row="allSectionFormsCount" @page-change="paginate"></v-page>

                        <va-button style="margin-left: 10px" @click.native="paginate({pageNumber: page})">
                            <va-icon type="sync-alt"></va-icon>
                        </va-button>
                    </div>
                </va-column>

            </va-row>

        </div>

        <div v-else class="deadCenter">
            <p>{{ _('No layout available') }}</p>
        </div>

    </div>
</template>

<script>
    // @ is an alias to /src
    import { mapGetters, mapActions } from "vuex";
    import Parse from "@/main.js"

    export default {

        data() {
            return {
                page: 1,
                allSectionFormsCount: 0,
                perPageSectionForms: [],
                disableCatDeleteBtn: false,

                parentRoute: '',
                workspace: '',
                section: '',
                sectionCapitalized: '',
                category: null,
                currentDepartment: null,
            };
        },



        computed: {
            ...mapGetters(['user', 'loading', 'getSystemLanguage', 'getDirectionStatus', 'getCurrentCategory', 'getCurrentDepartment']),

            getCategory() {
                return this.category || this.getCurrentCategory
            },

            pageNumbers() {
                if (this.allSectionFormsCount <= 10) return 1
                else return Math.ceil(this.allSectionFormsCount / 10)
            },

        },

        methods: {
            ...mapActions(['setLoading']),

            deleteObject(object) {
                this.g_deleteObject(object)
                    .then(async result => {
                        if (result) {
                            this.$store.commit('setLoading', true)
                            await this.fetchAllSectionFormsCount()
                            await this.fetchSectionFormsPerPage()
                        }

                    }).catch(e => {

                    })
            },

            async fetchSectionFormsPerPage(pageNumber) {
                let q = new Parse.Query('Form')
                q.equalTo('type', this.section)
                q.equalTo('category', this.getCategory)
                q.equalTo('department', this.currentDepartment)
                q.descending('createdAt')
                q.skip((pageNumber - 1) * 25)
                q.limit(25)
                this.perPageSectionForms = await q.find()
                this.$store.commit('setLoading', false)
            },

            async fetchAllSectionFormsCount() {
                let q = new Parse.Query('Form')
                q.equalTo('type', this.section)
                q.equalTo('category', this.getCategory)
                q.equalTo('department', this.currentDepartment)
                this.allSectionFormsCount = await q.count()
            },

            async paginate(page) {
                this.page = page.pageNumber
                this.$store.commit('setLoading', true)
                await this.fetchSectionFormsPerPage(page.pageNumber)
            },

            navigate(to) {
                this.$router.push(to);
            },
        },

        async mounted() {
            this.section = this.$route.matched[0].name.substring(0, this.$route.matched[0].name.length - 1)
            this.sectionCapitalized = this.section.charAt(0).toUpperCase() + this.section.slice(1)
            this.category = this.getCurrentCategory
            this.currentDepartment = this.getCurrentDepartment
            this.$store.commit('setLoading', true)
            await this.fetchAllSectionFormsCount()
            await this.fetchSectionFormsPerPage(1);
        }
    };
</script>

<style>
    .actions_btn:hover {
        color: black !important
    }
</style>